import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

import {ClearCacheProvider} from 'react-clear-cache';
import store from './redux/index'
import {Provider} from 'react-redux'
import ErrorBoundary from './components/ErrorBoundary';


// Best-effort global error capture so the native side can pick it up via the bridge
try {
    window.addEventListener("error", function (ev) {
        try {
            console.error("window.onerror", ev?.message, ev?.filename, ev?.lineno, ev?.error?.stack);
        } catch (e) {}
    });
    window.addEventListener("unhandledrejection", function (ev) {
        try {
            const reason = ev?.reason;
            console.error("unhandledrejection", reason?.message || String(reason), reason?.stack);
        } catch (e) {}
    });
} catch (e) {}


//GET BORNE ID
window.ISWEB = !window.ReactNativeWebView

const searchParams = new URLSearchParams(window.location.search)
//console.log(searchParams)
if (searchParams.get("borne")) {
    window.BORNEID = searchParams.get("borne")
}

if (!window.BORNEID && localStorage.getItem("borne")) {
    window.BORNEID = localStorage.getItem("borne")

} else if (window.BORNEID) {
    try { localStorage.setItem("borne", window.BORNEID) } catch (_) {}
}


function render(node) {
    try {
        const root = ReactDOM.createRoot(document.getElementById('root'));
        root.render(node);
    } catch (e) {
        try {
            const el = document.getElementById('root');
            if (el) {
                el.innerHTML = '<div style="color:#fff;padding:20px;">Erreur de démarrage : ' + (e?.message || e) + '</div>';
            }
        } catch (_) {}
    }
}

if (!window.BORNEID) {
    //TEST MODE
    render(<div>Borne loaded</div>);
} else {
    render(
        <ErrorBoundary>
            <ClearCacheProvider duration={5000}>
                <Provider store={store}>
                    <App/>
                </Provider>
            </ClearCacheProvider>
        </ErrorBoundary>
    );
}
